export const initState = {
	showRegister: false,
	showLogin: false,
	showMobileMenu: false,

	$config: {},
};

export default initState;
